<div class="admin-tabs__container">
  @for (tab of tabs; track tab.id) {
    <button
      class="admin-tabs__tab"
      [class.admin-tabs__tab--active]="isTabActive(tab.id)"
      (click)="onTabClick(tab.id)"
      [attr.data-testid]="'professional-admin-tab-' + tab.id"
      type="button"
    >
      <span class="admin-tabs__tab-label">{{ tab.label }}</span>
    </button>
  }
</div>
